<template>
    <div class="form">
        <el-form :model="info" ref="info" label-width="120px" label-position="left" class="demo-info">
            <h3 class="sub-title">基础设置</h3>
            <el-form-item label="活动名称：" prop="name">
                <el-input v-model="info.name" :disabled="true" clearable placeholder="请输入活动名称，不超过20个字"></el-input>
            </el-form-item>
            <el-form-item label="活动时间：" prop="date">
                <el-date-picker
                    v-model="info.date"
                    style="width: 100%"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="expireTimeOption"
                    :disabled="true"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="活动类型：" prop="type">
                <el-radio-group v-model="info.type" :disabled="true">
                    <el-radio label="1">普通拼团</el-radio>
                    <!-- <el-radio label="2">阶梯拼团</el-radio> -->
                </el-radio-group>
                <p class="tip-text">用户下单开团后，邀请好友一起购买，以优惠价格购买，提升店铺转化</p>
            </el-form-item>
            <el-form-item label="参团人数：" prop="number">
                <el-input v-model="info.number" :disabled="true" oninput="value=value.replace(/[^\d]/g,'')" clearable placeholder=" 至少2人" style="width: 240px">
                    <template slot="append">人</template>
                </el-input>
            </el-form-item>

            <el-form-item label="活动有效期：" prop="task_time">
                <div>
                    <el-input-number v-model="info.dd" :disabled="true" clearable style="width: 120px" :min="0" :max="30"> </el-input-number> 日
                    <span v-show="info.dd != 30"> <el-input-number v-model="info.hh" :disabled="true" clearable :min="0" :max="23" style="width: 120px; margin-left: 16px"> </el-input-number> 时</span>
                    <span v-show="info.dd != 30"> <el-input-number v-model="info.mm" :disabled="true" clearable :min="0" :max="59" style="width: 120px; margin-left: 16px"> </el-input-number> 分</span>
                </div>
                <p class="tip-text">拼团活动有效期需在15分钟至30天之间 若设置1日，用户开团后，需要在1日内成团，超时则失败</p>
            </el-form-item>

            <el-form-item label="优惠叠加：" prop="coupon_type">
                <el-radio-group v-model="info.coupon_type" :disabled="true">
                    <el-radio label="1">不叠加其他营销活动或优惠券</el-radio>
                </el-radio-group>
            </el-form-item>
            <h3 class="sub-title">更多设置</h3>
            <el-form-item label="在线凑团：" prop="on_line_group">
                <el-radio-group v-model="info.on_line_group" :disabled="true">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="2">关闭</el-radio>
                </el-radio-group>
                <p class="tip-text">开启后，商品详情会显示未成团的团，用户可任意选一个参团，提升成团率</p>
            </el-form-item>
            <el-form-item label="模拟成团：" prop="analog_group">
                <el-radio-group v-model="info.analog_group" :disabled="true">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="2">关闭</el-radio>
                </el-radio-group>
                <p class="tip-text">开启后，当在拼团有效期内或拼团活动结束前，人数未满的团，系统将会模拟“匿名”买家凑满人数，使其成团</p>
                <p class="warn-text">注意：模拟成团的团长也可以享受团长价格，请谨慎设置</p>
                <el-input
                    v-if="info.analog_group == 1"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    v-model="info.analog_group_number"
                    clearable
                    style="width: 320px; margin-top: 16px"
                    placeholder="模拟参团人数需小于参团人数"
                    :disabled="true"
                >
                    <template slot="append">人</template>
                </el-input>
            </el-form-item>
            <el-form-item label="团长价：" prop="is_open_leader_price">
                <el-radio-group v-model="info.is_open_leader_price" :disabled="true">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="2">关闭</el-radio>
                </el-radio-group>
                <p class="tip-text">开启后，团长（开团人）将享受更优惠价格，有助于提高开团率和成团率</p>
                <p class="warn-text">注请注意：模拟成团的团长也能享受团长优惠，请谨慎设置，避免资金损失</p>
            </el-form-item>
            <el-form-item label="活动预热：" prop="activity_prepare">
                <el-radio-group v-model="info.activity_prepare" :disabled="true">
                    <el-radio label="1">开启</el-radio>
                    <el-radio label="2">关闭</el-radio>
                </el-radio-group>
                <p class="tip-text">开启后，会即时在商品详情页展示尚未开始的拼团活动预告；活动开始后，用户才能使用拼团价格</p>
            </el-form-item>
            <!-- <el-form-item label="活动商品：">
                        <el-button type="primary" @click="showGoods" size="small" style="margin-right: 12px">添加</el-button>
                        <span v-if="count">已添加 {{ count }} 个商品</span>
                    </el-form-item> -->
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
        };
    },
    props: {
        info: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    padding: 40px 60px;
    width: 80%;
}

::v-deep .el-range-editor.is-disabled input,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}

.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
      &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

</style>